import { createReducer } from '@reduxjs/toolkit';
import { hide, show } from './actions';

type ThemeBlackState = {
    value: boolean;
};

const initialState: ThemeBlackState = {
    value: false,
};

export const themeBlackReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(show, (state) => {
            state.value = true;
        })
        .addCase(hide, (state) => {
            state.value = false;
        });
});
